export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-loading/index.js